import Box from "glesys-controlpanel/components/box";
import Table from "glesys-controlpanel/components/table";
import TableTd from "glesys-controlpanel/components/table/td";
import TableTh from "glesys-controlpanel/components/table/th";
import GButton from "glesys-controlpanel/components/g-button";
import modal from "glesys-controlpanel/helpers/modal";
import canManage from "glesys-controlpanel/helpers/can-manage";
import { on } from "@ember/modifier";
import { t } from "ember-intl";

<template>
  <Box data-test-database-details-firewall>
    <:header>{{t "label.firewall"}}</:header>
    <:default>
      <span class="text-gray-500 text-base">{{t "databases.details.firewall.info"}}</span>
      <Table class="mx-[-25px] mt-8" @items={{@database.allowlist}} @footer={{false}} @outsideBorders={{false}}>
        <:header>
          <TableTh>{{t "databases.details.firewall.table-header"}}</TableTh>
        </:header>
        <:body as |item|>
          <TableTd data-test-database-firewall-ip-item>{{item}}</TableTd>
        </:body>
        <:emptyState>
          <TableTd>{{t "databases.details.firewall.empty-state"}}</TableTd>
        </:emptyState>
      </Table>
    </:default>
    <:footer>
      {{#if (canManage)}}
        <GButton
          data-test-database-firewall-update-access
          @color="outline"
          {{on
            "click"
            (modal "modals/database-firewall-update-access" allowlist=@database.allowlist submitTask=@updateAccessTask)
          }}
        >{{t "button.manage-access"}}</GButton>
      {{/if}}
    </:footer>
  </Box>
</template>
